import { defineMeta } from '@/registry/types';

export const searchMeta = defineMeta({
  name: 'Search',
  level: 'molecule',
  category: 'input',
  classification: 'custom',
  description: 'Search field with leading icon, clear button and debounced change events.',
  baseLibrary: 'custom',
  muiEquivalent: 'TextField (composed)',
  muiDocs: 'https://mui.com/material-ui/react-text-field/',
  a2uiEquivalent: 'SearchBox',
  importPath: '@/molecules/Search',
  optionalProps: ['value', 'defaultValue', 'onSearch', 'onChange', 'debounceMs', 'placeholder'],
  props: [
    { name: 'onSearch', type: '(value: string) => void', description: 'Debounced search callback' },
    { name: 'debounceMs', type: 'number', default: '300' },
  ],
  customVariants: [],
  supportedStates: ['empty', 'typing', 'has-value', 'disabled'],
  designTokens: ['colors', 'radius'],
  accessibility: [
    'Clear button has an aria-label.',
    'Provide an associated label or aria-label for the field when no visible label.',
  ],
  usageExamples: ['<Search onSearch={(q) => fetch(q)} placeholder="Search assets..." />'],
  rules: [
    'Every search or filter input is the design-system Search - in new UI, and in any UI you revamp or refactor. Never a TextField with a magnifier InputAdornment, an OutlinedInput, or a raw <input>.',
    'When refactoring, replace existing hand-rolled search inputs with Search rather than leaving them in place.',
    'Use `onSearch` for anything expensive (network requests, large filters); it is debounced via `debounceMs` (default 300). Use `onChange` only when you need every keystroke.',
    'Give it a placeholder that names what is being searched ("Search assets...", "Search findings..."), and an aria-label when there is no visible label.',
  ],
  antiPatterns: ['Do not trigger expensive queries on every keystroke; rely on onSearch debounce.'],
  llmSafe: true,
  whenToUse: ['Filtering lists/tables', 'Global search bars'],
  whenNotToUse: ['Selecting from a fixed known set (use Select/Autocomplete)'],
});

export default searchMeta;
